export class SetLayoutAction {
    constructor(layout) {
        this.name = 'SetLayout';
        this.isDeviceAction = true;
        this.data = {};
        this.data.layout = layout.layout;
        this.data.layoutData = layout.parameters;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2V0TGF5b3V0QWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9tb2RlbHMvYWN0aW9ucy9TZXRMYXlvdXRBY3Rpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0EsTUFBTSxPQUFPLGVBQWU7SUFLMUIsWUFBWSxNQUFxQjtRQUpqQixTQUFJLEdBQUcsV0FBVyxDQUFDO1FBQ25CLG1CQUFjLEdBQUcsSUFBSSxDQUFDO1FBQy9CLFNBQUksR0FBaUMsRUFBRSxDQUFDO1FBRzdDLElBQUksQ0FBQyxJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQyxNQUFNLENBQUM7UUFDakMsSUFBSSxDQUFDLElBQUksQ0FBQyxVQUFVLEdBQUcsTUFBTSxDQUFDLFVBQVUsQ0FBQztJQUMzQyxDQUFDO0NBQ0YifQ==